export const singleLineRibbonLabel = "mbcql";
export const multiLineRibbonLabel = "$QJUlb";
export const layoutHeaderLabel = "f0pe7";
export const ribbonLayoutButtonLabel = "MAZm2b";
export default {singleLineRibbonLabel,multiLineRibbonLabel,layoutHeaderLabel,ribbonLayoutButtonLabel};